export const FETCHING_COLLECTIONS = 'FETCHING_COLLECTIONS'
export const FETCHED_COLLECTIONS = 'FETCHED_COLLECTIONS'
export const NO_LOGGED_COLLECTIONS = 'NO_LOGGED_COLLECTIONS'
export const FETCHED_COLLECTIONS_META = 'FETCHED_COLLECTIONS_META'

const collectionsInit = {
  isFetching: false,
  data: {}
}

export function collections(collections=collectionsInit, action) {
  switch(action.type) {
    case FETCHING_COLLECTIONS:
      return {
        isFetching: true,
        data: {},
      }
    case FETCHED_COLLECTIONS:
      return {
        isFetching: false,
        data: action.collections,
      }
    default:
      return collections
  }
}

export function collectionsMeta(
  meta={
    count: 0,
    maxPage: 0,
    currentPage: 1,
  },
  action
) {
  switch(action.type) {
    case FETCHED_COLLECTIONS_META:
      return action.meta
    default:
      return meta
  }
}
